<template>
  <v-chip v-if="schoolId" small outlined :to="collegeRoute" target="_blank">
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  name: 'SupportRequestSchoolChip',
  props: {
    schoolId: { type: Number, default: null },
    schoolName: { type: String, default: null },
  },
  computed: {
    collegeRoute() {
      return this.schoolId ? `/dashboard/colleges/${this.schoolId}` : undefined;
    },
    // Muestra el nombre cuando el backend lo manda; si todavía no lo manda,
    // cae al ID como antes (KB-900).
    label() {
      return this.schoolName
        ? this.$t('supportRequests.card.school', { name: this.schoolName })
        : this.$t('supportRequests.card.school_id', { id: this.schoolId });
    },
  },
};
</script>
